import React, { useState } from 'react';
import axios from 'axios';

const VideoForm = () => {
  const [title, setTitle] = useState('');
  const [thumbnailUrl, setThumbnailUrl] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
  
    // Automatically generate thumbnail URL based on the YouTube video URL
    const videoId = videoUrl.split('v=')[1];
    const generatedThumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_REQUESTING_API}/api/videos`, {
        title,
        thumbnailUrl: generatedThumbnailUrl, // Use the auto-generated thumbnail URL
        videoUrl,
      });
      setMessage(response.data.message);
      setTitle('');
      setThumbnailUrl('');
      setVideoUrl('');
    } catch (error) {
      setMessage('Failed to add video');
    }
  };
  

  return (
    <div className="max-w-lg mx-auto bg-white shadow-md rounded-lg p-6 mt-40">
      <h2 className="text-2xl font-bold mb-4 text-center">Add a New Video</h2>

      <form onSubmit={handleSubmit} className="space-y-10">
        <div>
          <label className="block text-gray-700">Title:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-slate-400"
            placeholder="Video title"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700">Thumbnail URL:</label>
          <input
            type="text"
            value={thumbnailUrl}
            onChange={(e) => setThumbnailUrl(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-slate-400"
            placeholder="Thumbnail URL"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700">Video URL:</label>
          <input
            type="text"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-slate-400"
            placeholder="YouTube Video URL"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-slate-800 text-white font-bold py-2 px-4 rounded-lg hover:bg-slate-500 focus:outline-none"
        >
          Submit
        </button>

        {message && <p className="text-center mt-4 text-green-500">{message}</p>}
      </form>
    </div>
  );
};

export default VideoForm;
